import React from 'react';
import { Link } from 'react-router-dom';

const cx = (...c) => c.filter(Boolean).join(' ');

/** variant: primary | dark | outline | danger-outline | ghost | on-primary | on-primary-outline */
export default function Button({
  variant = 'primary', size, block, loading, to, href, className, children, disabled, type = 'button', ...rest
}) {
  const cls = cx('btn', `btn--${variant}`, size && `btn--${size}`, block && 'btn--block', className);
  const content = loading ? <span className="btn__spinner" aria-label="Loading" /> : children;

  if (to && !disabled) {
    return <Link to={to} className={cls} {...rest}>{content}</Link>;
  }
  if (href) {
    return <a href={href} className={cls} {...rest}>{content}</a>;
  }
  return (
    <button type={type} className={cls} disabled={disabled || loading} {...rest}>
      {content}
    </button>
  );
}
